import { Container } from "../../../../styledComponents/Container/styled";
import { HeaderCustom } from "../../../../../../styled";


const Package = () => (
    <Container>
    <HeaderCustom>Tworzenie stron internetowych, zakotwiczenie na hostingu, dobór domeny, stworzenie social mediów, optymalizacja witryny, pozycjonowanie</HeaderCustom>
  </Container>
);

export default Package;